import type { LocaleObject } from "@nuxtjs/i18n";
import type { NuxtConfig } from "nuxt/schema";

export const availableLocales = [
  {
    code: "en",
    language: "en-GB",
    ogLocale: "en_GB",
    file: "en_GB.json",
    abbreviation: "en",
    name: "English (UK)",
  },
  {
    code: "us",
    language: "en-US",
    ogLocale: "en_US",
    file: "en_US.json",
    abbreviation: "en",
    name: "English (US)",
  },
  {
    code: "nl",
    language: "nl-NL",
    ogLocale: "nl_NL",
    file: "nl_NL.json",
    abbreviation: "nl",
    name: "Nederlands",
  },
  {
    code: "fr",
    language: "fr-FR",
    ogLocale: "fr_FR",
    file: "fr_FR.json",
    abbreviation: "fr",
    name: "Français",
  },
  {
    code: "de",
    language: "de-DE",
    ogLocale: "de_DE",
    file: "de_DE.json",
    abbreviation: "de",
    name: "Deutsch",
  },
  {
    code: "it",
    language: "it-IT",
    ogLocale: "it_IT",
    file: "it_IT.json",
    abbreviation: "it",
    name: "Italiano",
  },
  {
    code: "es",
    language: "es-ES",
    ogLocale: "es_ES",
    file: "es_ES.json",
    abbreviation: "es",
    name: "Español",
  },
  {
    code: "pt",
    language: "pt-PT",
    ogLocale: "pt_PT",
    file: "pt_PT.json",
    abbreviation: "pt",
    name: "Português",
  },
  {
    code: "br",
    language: "pt-BR",
    ogLocale: "pt_BR",
    file: "pt_BR.json",
    abbreviation: "pt",
    name: "Português do Brasil",
  },
  {
    code: "ja",
    language: "ja-JP",
    ogLocale: "ja_JP",
    file: "ja_JP.json",
    abbreviation: "ja",
    name: "日本語",
  },
  {
    code: "zh",
    language: "zh-CN",
    ogLocale: "zh_CN",
    file: "zh_CN.json",
    abbreviation: "zh",
    name: "简体中文",
  },
  {
    code: "tr",
    language: "tr-TR",
    ogLocale: "tr_TR",
    file: "tr_TR.json",
    abbreviation: "tr",
    name: "Türkçe",
  },
  {
    code: "ko",
    language: "ko-KR",
    ogLocale: "ko_KR",
    file: "ko_KR.json",
    abbreviation: "ko",
    name: "한국어",
  },
] as const satisfies LocaleObject[];

/**
 * See: https://i18n.nuxtjs.org/getting-started/setup
 */
const nuxtI18nModuleConfig = {
  strategy: "prefix_and_default",
  compilation: {
    strictMessage: false, // so that the html messages in the translations don't break the build
  },
  langDir: "crowdin/",
  locales: availableLocales,
  defaultLocale: "en",
  // We handle browser language detection ourselves on the client,
  // as it intervenes with our initial doc caching.
  detectBrowserLanguage: false,
  vueI18n: "./vueI18nConfig.ts",
  experimental: {
    typedOptionsAndMessages: "all",
    httpCacheDuration: 60 * 60 * 24, // 24 hours
  },
} satisfies NuxtConfig["i18n"];

export default nuxtI18nModuleConfig;
